import 'twin.macro'

import { AnimatePresence } from 'framer-motion'

import { Step } from './steps-swiper'

const StepAnimation = ({ steps, activeIdx }: { steps: Array<Step>; activeIdx: number }) => {
  return (
    <div tw='absolute top-0 left-1/2 -translate-x-1/2'>
      <AnimatePresence>
        {steps.map(step => {
          if (step.step === activeIdx + 1) {
            return step.component
          }
        })}
      </AnimatePresence>
    </div>
  )
}

export default StepAnimation
